//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.IntAdapter
import com.apollographql.apollo.api.Optional
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.UploadAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.nullable
import com.apollographql.apollo.api.present
import com.wintermar.inspection.graphql.type.FileUploadCommandInput
import kotlin.IllegalStateException

public object FileUploadCommandInput_InputAdapter : Adapter<FileUploadCommandInput> {
  override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): FileUploadCommandInput = throw IllegalStateException("Input type used in output position")

  override fun toJson(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    `value`: FileUploadCommandInput,
  ) {
    writer.name("id")
    AnyAdapter.toJson(writer, customScalarAdapters, value.id)
    writer.name("fileName")
    StringAdapter.toJson(writer, customScalarAdapters, value.fileName)
    writer.name("chunk")
    UploadAdapter.toJson(writer, customScalarAdapters, value.chunk)
    writer.name("chunkIndex")
    IntAdapter.toJson(writer, customScalarAdapters, value.chunkIndex)
    writer.name("totalChunks")
    IntAdapter.toJson(writer, customScalarAdapters, value.totalChunks)
    writer.name("fileCategory")
    FileCategory_ResponseAdapter.toJson(writer, customScalarAdapters, value.fileCategory)
    if (value.bunkerActivityDocumentType is Optional.Present) {
      writer.name("bunkerActivityDocumentType")
      BunkerActivityDocumentType_ResponseAdapter.nullable().present().toJson(writer, customScalarAdapters, value.bunkerActivityDocumentType)
    }
  }
}
